import React, { useCallback, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import { IFlightOperator } from 'src/models/flight-operator.model';
import Lang from 'src/libraries/language';
import { getFlightOperatorStatus } from 'src/selectors/flight-operator.selector';
import { actionTypes } from 'src/ducks/flight-operator.duck';
import style from '../flight-operators-list/flight-operators-list.module.scss';

type IProp = {
  data: IFlightOperator;
};

const FlightOperatorsDelete: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useFlightOperatorContext();
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const deleteStatus = getFlightOperatorStatus(
    state,
    actionTypes.FLIGHT_OPERATOR_DELETE
  );

  const handleDelete = useCallback(async () => {
    if (data.operatorId) {
      const response = await actions.itemDELETE(data.operatorId);
      if (!response.error) {
        setIsDeleteOpen(false);
        actions.listGET();

        ToastSuccess(
          Lang.formatString(Lang.MSG_FLIGHT_OPERATOR_DELETE_SUCCESS, data.name)
        );
      } else {
        ToastError(response.error.message);
      }
    }
  }, [actions, data]);

  return (
    <ATMModal
      open={isDeleteOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="trash alternate outline"
          onClick={() => setIsDeleteOpen(true)}
        />
      }
      header={Lang.LBL_DELETE_FLIGHT_OPERATOR}
      content={
        <div className={style.content}>
          {Lang.formatString(
            data.Pilots && data.Pilots.length > 0
              ? Lang.MSG_CONFIRM_OPERATOR_PILOT_TAIL_DELETE
              : Lang.MSG_CONFIRM_OPERATOR_DELETE,
            data.name
          )}
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => setIsDeleteOpen(false)}
          />
          <ATMButton
            negative
            content={Lang.LBL_YES_DELETE}
            onClick={handleDelete}
            disabled={deleteStatus.fetching}
            loading={deleteStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default FlightOperatorsDelete;
